export const evaluationDict = {
  self_q1: {
    4: '积极参与体育活动，出勤情况优秀',
    3: '积极参与体育活动，出勤情况良好',
    2: '体育参与表现一般，有提升空间',
    1: '在运动参与积极性方面还需加强',
    0: '运动参与情况暂未记录',
  },
  self_q2: {
    4: '意志力顽强，能够克服困难坚持到底',
    3: '意志力较强，能够坚持完成活动',
    2: '意志力表现一般，需进一步锻炼',
    1: '遇到困难时容易放弃，需加强',
    0: '意志力情况暂未记录',
  },
  self_q3: {
    4: '运动技能掌握扎实，动作规范标准',
    3: '运动技能掌握较好，动作较为规范',
    2: '运动技能掌握一般，仍有进步空间',
    1: '运动技能方面还需多加练习',
    0: '技能认知情况暂未记录',
  },
  self_q4: {
    4: '技能提升显著，进步非常明显',
    3: '技能有所提升，进步较为明显',
    2: '技能提升一般，仍需继续努力',
    1: '技能提升较慢，需要更多练习',
    0: '技能提升情况暂未记录',
  },
  self_q5: {
    4: '健康安全意识很强，能够自我保护',
    3: '健康安全意识较强，注意自我保护',
    2: '健康安全意识一般，需加强',
    1: '健康安全意识较弱，需提高警惕',
    0: '健康安全情况暂未记录',
  },
  self_q6: {
    4: '健康准备非常充分，装备齐全',
    3: '健康准备较为充分，装备基本齐全',
    2: '健康准备一般，偶有遗漏',
    1: '健康准备不够充分，经常遗漏物品',
    0: '健康准备情况暂未记录',
  },
  self_q7: {
    4: '品德守序方面表现优秀，严格遵守规范',
    3: '品德守序表现良好，遵守相关规定',
    2: '品德守序表现一般，需继续保持',
    1: '品德守序表现较差，偶尔违反规定',
    0: '品德守序情况暂未记录',
  },
  self_q8: {
    4: '品德激励表现优秀，能够鼓励帮助他人',
    3: '品德激励表现良好，偶尔帮助鼓励他人',
    2: '品德激励表现一般，有待加强',
    1: '品德激励表现较差，较少主动鼓励他人',
    0: '品德激励情况暂未记录',
  },
  peer_q1: {
    3: '情绪支持表现优秀，能够给予同学情感上的支持',
    2: '情绪支持表现一般，仍有提升空间',
    1: '情绪支持表现较差，需要更多关心同学',
    0: '情绪支持情况暂未获得同伴反馈',
  },
  peer_q2: {
    3: '协助支持表现优秀，是团队的宝贵成员',
    2: '协助支持表现一般，仍有进步空间',
    1: '协助支持表现较差，需要更积极主动',
    0: '协助支持情况暂未获得同伴反馈',
  },
  peer_q3: {
    3: '安全尊重表现优秀，尊重同学安全和尊严',
    2: '安全尊重表现一般，需继续保持',
    1: '安全尊重表现较差，需要改进',
    0: '安全尊重情况暂未获得同伴反馈',
  },
  peer_q4: {
    3: '努力程度表现优秀，是团队中最努力的成员之一',
    2: '努力程度表现一般，仍有提升空间',
    1: '努力程度表现较差，需要更加努力',
    0: '努力程度情况暂未获得同伴反馈',
  },
  teacher_q1: {
    4: '任务完成非常出色，超额达成目标',
    3: '任务完成良好，达到预期目标',
    2: '任务完成一般，基本达到要求',
    1: '任务完成较差，部分目标未达成',
    0: '任务完成情况暂未记录',
  },
  teacher_q2: {
    4: '学习态度非常端正，积极主动',
    3: '学习态度端正，认真努力',
    2: '学习态度一般，需进一步端正',
    1: '学习态度较差，需要改进',
    0: '学习态度情况暂未记录',
  },
  teacher_q3: {
    4: '纪律表现非常优秀，严格遵守课堂纪律',
    3: '纪律表现良好，遵守课堂纪律',
    2: '纪律表现一般，需继续保持',
    1: '纪律表现较差，需要加强自律',
    0: '纪律表现情况暂未记录',
  },
  teacher_q4: {
    4: '课堂氛围营造非常好，带动团队积极性',
    3: '课堂氛围良好，能够积极配合',
    2: '课堂氛围一般，需更加积极参与',
    1: '课堂氛围较差，影响团队氛围',
    0: '课堂氛围情况暂未记录',
  },
  overall_star: {
    4: '自评等级：优秀',
    3: '自评等级：良好',
    2: '自评等级：中等',
    1: '自评等级：需努力',
    0: '自评等级：暂未评定',
  },
} as const;

export type EvalDictKey = keyof typeof evaluationDict;
export type EvalDictValue<K extends EvalDictKey> = (typeof evaluationDict)[K];